/* import __COLOCATED_TEMPLATE__ from './card-stats.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type ContentStatistic from 'embercom/models/outbound/content-statistic';
import { statisticKeys } from 'embercom/models/data/outbound/constants';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  aiStats: ContentStatistic[];
  loadingAiStats: boolean;
}

export default class CardStats extends Component<Args> {
  @service declare intl: IntlService;

  get receiptsStatistic() {
    return this.getStatObject('receipts');
  }

  get finHelpfulAnswersStatistic() {
    return this.getStatObject('finHelpfulAnswers');
  }

  get resolutionRate(): number {
    let receipts = this.receiptsStatistic?.value;
    let resolutions = this.finHelpfulAnswersStatistic?.value;

    if (!receipts || !resolutions || receipts === 0) {
      return 0;
    }

    let percentage = (resolutions / receipts) * 100;
    return Number(percentage.toFixed(2));
  }

  get receiptsStatisticValue() {
    return this.receiptsStatistic?.value || 0;
  }

  get finHelpfulAnswersStatisticValue() {
    return this.finHelpfulAnswersStatistic?.value || 0;
  }

  private getStatObject(statName: 'receipts' | 'finHelpfulAnswers') {
    let key = statisticKeys[statName];
    return this.args.aiStats.find((stat) => stat && stat.key === key) || null;
  }

  get tooltipText() {
    return this.intl.t('knowledge-hub.content-editor.side-by-side-review.card.tooltip-text');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::SideBySideReview::CardStats': typeof CardStats;
    'knowledge-hub/content-editor/side-by-side-review/card-stats': typeof CardStats;
  }
}
